import { ProjectIcon } from './ProjectIcon';
export default ProjectIcon;
